<template>
  <div class="cpt-rules">
    <div class="label">抽奖规则</div>
    <template v-if="!isLinkGacha">
      <div class="content">
        <div class="title">中奖号码计算方法</div>
        <div class="text">
          <ul>
            <li>
              取每日<a href="https://store.steampowered.com/stats/support"
                >Steam客服的新建请求数</a
              >的233333倍作为随机数A，A=新建请求数*233333；
            </li>
            <li>取本次抽奖活动的所有盒券总数作为B；</li>
            <li>计算A除以B，得到的的余数即为中奖号码；</li>
            <li>
              如有多个中奖名额，则中奖号码通过<br />A%（B+n）来顺序计算，此外若出现两个中奖号码属于同一人的情况，则剔除后继续按序计算。
            </li>
          </ul>
        </div>
        <div class="title">举例</div>
        <div class="text">
          <ul>
            <li>例如Steam客服统计数据是171535，则随机数A=40024776155</li>
            <li>本次抽奖所有盒券总数为520000张，则B=520000</li>
            <li>
              A除以B得76970余376155，则中奖号码为376155，持有盒券编号为376155的用户即为中奖用户
            </li>
            <li>
              若本轮抽奖抽出5份奖品，则第二个中奖号码为A除以（B+1）得76950余299185，中奖编号为299185。第三个中奖号码为A除以（B+2）得76970余222215，中奖编号222215。若抽出的299185和222215属于同一个用户，则舍弃该号码并计算A%（B+3）得到第三个中奖号码。以此类推，直至得到5个不同用户作为中奖用户为止。
            </li>
          </ul>
        </div>
        <div class="title">其他规则</div>
        <div class="text">
          <ul>
            <li>
              由于Steam客服统计数据会在每日15点更新前一日的数据，因此开奖时间在当日0点-15点的，会在当日15点开奖；开奖时间在当日15点-24点的，会在次日15点开奖；如因Steam原因导致无法获得数据的，则待数据更新时自动开奖，因该原因造成的任何问题，小黑盒官方不承担任何责任；
            </li>
            <li>
              关于开奖数据的选取，例如：5月5日15:00，Steam会更新5月4日的客服统计数据，开奖时间在5月4日15:00到5月5日15:00之间的，根据5月4日15:00的Steam客服统计数据进行开奖。
            </li>
            <li>
              本抽奖活动仅限小黑盒用户参与，参与用户在抽奖活动中可完成各项任务获得对应张数的“盒券”，每张“盒券”都带有唯一编号，“盒券”编号从0开始编号，开奖时系统会自动抽取相应数量的编号作为中奖号码，用户持有中奖编号的“盒券”即中奖；
            </li>
            <li>
              开奖时系统会在抽奖页面进行公示相关信息，包括但不限于中奖号码、中奖用户头像、中奖用户昵称等，开奖后中奖用户需在3个自然日（72小时）内在小黑盒站内信填写收货信息，如因中奖用户未在指定期限内填写收货信息或填写收货信息错误导致无法发货的，则视为放弃中奖机会；
            </li>
            <li>
              每轮抽奖活动同一用户最多可获得1份中奖奖品，如抽出的多个中奖号码经平台核实属于同一用户则仅算作一次中奖，其他奖品自动取消。相同收货手机号、支付账号、硬件设备、收货地址等其他任何可判定为同一用户的情形均视为同一用户；
            </li>
            <li>
              用户不得使用外挂、脚本、插件等任何第三方程序以及任何破坏活动规则、违背活动公平原则的方式参与本次活动（包括但不限于批量注册、机器模拟客户端、使用非法客户端等舞弊行为），一经发现，小黑盒官方有权取消用户参与本次活动的资格、封禁账号同时有权回收已经发放的奖品、取消还未发放的奖品，保留拒绝其参与本公司任何活动的权利，并追究相关法律责任；<br />
            </li>
            <li>本活动与苹果公司无关，苹果公司没有以任何形式参与活动；</li>
            <li>
              如有未尽事宜，以小黑盒官方解释为准，小黑盒官方保留活动的最终解释权。
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="content">
        <div class="text">
          1.
          小黑盒不支持任何返利抽奖或者转账抽奖，所有需要中奖者转账、支付的都是诈骗行为，如有类似的情况出现，请及时联系客服；
        </div>
        <div class="text">
          2.
          本活动仅限真实的小黑盒用户参与，参与用户在完成指定条件的任务后，可以参与抽奖；
        </div>
        <div class="text">
          3.
          每个抽奖活动同一用户最多可获得1份中奖奖品，如抽出的多个中奖号码经平台核实属于同一用户则仅算作一次中奖，其他奖品自动取消。相同收货手机号、支付账号、硬件设备、收货地址等其他任何可判定为同一用户的情形均视为同一用户；
        </div>
        <div class="text">
          4.
          开奖时系统会在抽奖页面进行公示相关信息，包括但不限于中奖用户头像、中奖用户昵称等；
        </div>
        <div class="text">
          5.
          CDKEY奖品有兑换的有效期，中奖后请尽快兑换使用，如果因为超过兑换时间导致兑奖失败平台概不负责；
        </div>
        <div class="text">
          6.
          用户不得使用外挂、脚本、插件等任何第三方程序以及任何破坏活动规则、违背活动公平原则的方式参与本次活动（包括但不限于批量注册、机器模拟客户端、使用非法客户端等舞弊行为），一经发现，小黑盒官方有权取消用户参与本次活动的资格、封禁账号同时有权回收已经发放的奖品、取消还未发放的奖品，保留拒绝其参与本公司任何活动的权利，并追究相关法律责任；
        </div>
        <div class="text">
          7. 本活动与苹果公司无关，苹果公司没有以任何形式参与活动；
        </div>
        <div class="text">
          8.
          如有未尽事宜，以小黑盒官方解释为准，小黑盒官方保留活动的最终解释权。
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'rules',
  props: {
    isLinkGacha: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.cpt-rules {
  padding-top: 12px;
  .label {
    margin: 0 0 20px 12px;
    font-weight: 500;
    font-size: 16px;
    color: #14191e;
  }
  .content {
    height: calc(100vh - 175px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .title {
      margin-bottom: 12px;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      color: #000000;
    }
    .text {
      margin: 0 17px 20px 7px;
      font-size: 15px;
      line-height: 21px;
      color: #000000;
      ol,
      ul {
        padding-left: 20px;
      }
      .point-outer {
        display: inline-block;
        height: 20px;
        .point {
          display: inline-block;
          margin-bottom: 3px;
          width: 5px;
          height: 5px;
          background-color: #000000;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
